module.exports = __webpack_public_path__ + "img/illu-card-beschwerden-sensory-perception.707327f3.svg";